module.exports = "<div id=inbox> <title title=\"Vue Mail\"></title> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Root.vue
 ** module id = 28
 ** module chunks = 0
 **/